import React, { useState } from "react";
import { Formik } from "formik";
import { useSelector } from "react-redux";
import * as Yup from "yup";
import axios from "utils/axios";
import LogInMobilePopUp from "views/Auth/SignInSendMobileOTP/LogInMobilePopUp";
import TestimonialsNew from "./TestimonialsNew";
import Footer from "./Footer";

const BookDemo = ({ interest, ...rest }) => {
  const [openLogInModal, setOpenLogInModal] = useState(false);
  const [thankYoumsg, setThankYoumsg] = useState(false);
  const auth = useSelector((state) => state.auth);
  const userProfile = auth.user;
  const phoneNumber = "+91-9373759782";

  const handleClick = () => setOpenLogInModal(true);
  const handleCloseLogInModal = () => setOpenLogInModal(false);

  const validationSchema = Yup.object().shape({
    name: Yup.string()
      .required("Name is required")
      .matches(/^[a-zA-Z\s]*$/, "Name should contain only alphabets"),
    number: Yup.number()
      .typeError("Mobile number must be a number")
      .required("Mobile number is required")
      .test(
        "len",
        "Mobile number must be 10 digits",
        (val) => val && val.toString().length === 10
      ),
  });

  return (
    <Formik
      initialValues={{
        name: "",
        number: "",
        interestShown:
          interest === "Get Started Free"
            ? "Get Started Free"
            : "Book a Demo",
      }}
      validationSchema={validationSchema}
      onSubmit={async (values, { setSubmitting }) => {
        try {
          const response = await axios.post(
            "/api/auth/demo/request",
            values
          );
          if (response.data.error === false) {
            setThankYoumsg(true);
          }
        } catch (error) {
          console.error("Error:", error);
          setSubmitting(false);
        }
      }}
    >
      {({
        handleSubmit,
        values,
        handleChange,
        errors,
        touched,
        handleBlur,
      }) => (
        <>
        <div>
          <div className="bg-[#FBF8F6] px-[21px] py-[45px] md:px-[45px] md:py-[48px] flex flex-col md:flex-row items-center md:justify-between">

            {/* LEFT SECTION */}
            <div>
              <h1 className="font-semibold text-[36px] tracking-[-1.44px] text-[#111827] mb-[29px] text-center md:text-left">
                Beyond a Tool. Your Competitive Edge in Cost Control
              </h1>

              <div className="max-w-[496px] md:max-w-[477px]">
                <p className="text-[18px] md:text-[20px] font-medium leading-[28px] text-black text-center md:text-left">
                  India's leading platform purpose-built to replace Excel chaos with smarter, faster Purchase & Contracting decisions.
                </p>
              </div>
              <div className="max-w-[496px] md:max-w-[477px] mt-4">
                <p className="text-[18px] md:text-[20px] font-medium leading-[28px] text-black text-center md:text-left">
                  Contact Us +91-9373759782
                </p>
              </div>
            </div>

            {/* FORM SECTION */}
            {!thankYoumsg && (
              <form onSubmit={handleSubmit} {...rest} className="mt-[54px] md:mt-0">
                <div className="max-w-[457px] bg-white px-[37px] py-[36px] md:px-[35px] md:pt-[28px] md:pb-[38px]">

                  <h2 className="text-2xl leading-[28px] md:leading-[39px] font-normal">
                    Search vendors & manage RFQs all from one place
                  </h2>

                  <div className="my-[25px] mb-[56px] flex flex-col gap-[16px]">

                    {/* Name */}
                    <div>
                      <label className="text-[12px] text-[#5E5873]">
                        Name
                      </label>
                      <input
                        type="text"
                        name="name"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.name}
                        placeholder="Name"
                        className="w-full border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-orange-500"
                      />
                      {touched.name && errors.name && (
                        <p className="text-red-500 text-sm mt-1">
                          {errors.name}
                        </p>
                      )}
                    </div>

                    {/* Number */}
                    <div>
                      <label className="text-[12px] text-[#5E5873]">
                        Number
                      </label>
                      <input
                        name="number"
                        value={values.number}
                        placeholder="Number"
                        onBlur={handleBlur}
                        onChange={(e) => {
                          const numericValue = e.target.value.replace(
                            /[^0-9]/g,
                            ""
                          );
                          handleChange({
                            target: { name: "number", value: numericValue },
                          });
                        }}
                        className="w-full border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-orange-500"
                      />
                      {touched.number && errors.number && (
                        <p className="text-red-500 text-sm mt-1">
                          {errors.number}
                        </p>
                      )}
                    </div>
                  </div>

                  {/* Submit Button */}
                  <div className="text-center">
                    <button
                      type="submit"
                      onClick={handleSubmit}
                      className="w-full bg-[#FD6600] text-white text-base py-3 rounded-[5px] hover:shadow-[0px_0px_10px_0px_rgba(0,0,0,0.7)] transition-all duration-300"
                    >
                      Submit
                    </button>
                  </div>

                  {!userProfile && (
                    <p className="text-[14px] mt-[14px]">
                      You already have your Business registered?
                      <span
                        onClick={handleClick}
                        className="text-[#3E69A3] underline cursor-pointer ml-1"
                      >
                        Login
                      </span>
                    </p>
                  )}
                </div>
              </form>
            )}
             {/* THANK YOU SECTION */}
            {thankYoumsg && (
              <div className="max-w-[475px] h-[512px] bg-white px-[21px] py-[58px] md:px-[33px] md:pt-[73px] md:pb-[85px] mt-[54px] md:mt-0">

                <h2 className="text-[#FD6600] text-center font-extrabold text-[28px] md:text-[36px] leading-[39px]">
                  Thank you !
                </h2>

                <p className="text-center text-[22px] md:text-lg leading-[39px] mt-2">
                  Your demo request has been submitted successfully.
                </p>

                <p className="text-center text-[18px] font-light leading-[30px] mt-[46px] max-w-[398px] mx-auto">
                  our sales executives will get in touch with you shortly.
                  In the meantime, if you have any urgent questions or
                  specific requirements, feel free to contact our support
                  team at
                  <span className="font-medium"> demo@neevay.com </span>
                  or call us at{" "}
                  <span className="font-medium">
                    <a href={`tel:${phoneNumber}`}>
                      {phoneNumber}
                    </a>
                  </span>
                </p>
              </div>
            )}
</div>
            <TestimonialsNew/>
            <Footer/>
           
          </div>

          <LogInMobilePopUp
            setOpenLogInModal={setOpenLogInModal}
            openLogInModal={openLogInModal}
            handleCloseLogInModal={handleCloseLogInModal}
          />
        </>
      )}
    </Formik>
  );
};

export default BookDemo;